import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const getAccessTree = async () => {
  const res = await request(API_ROUTES.accessLevel, { method: "GET" });
  if (!res.ok) throw new Error("Error fetching access tree");
  const json = await res.json();
  return json.data || [];
};

export const getRoles = async () => {
  try {
    const response = await request(API_ROUTES.rol, { method: "GET" });
    const json = await response.json();

    if (!json.success) {
      console.error("Error en API de roles:", json.message);
      return [];
    }

    // Adaptamos los nombres al formato usado por el front
    return json.data.map(r => ({
      id: parseInt(r.id_rol, 10),
      name: r.nombre,
      description: r.descripcion,
      status: r.estado
    }));
  } catch (error) {
    console.error("Error al obtener roles:", error);
    return [];
  }
};


export const saveRolePermissions = async (roleId, payload) => {
  const dataToSend = {
    roleId: roleId,
    acciones: payload.acciones
  };

  const rs = await request(API_ROUTES.savePermissionRol, { method: "PUT", body: JSON.stringify(dataToSend) })
    .then(r => r.json());

  return { success: true };
};

export const getRolePermissions = async (roleId) => {
  const response = await request(API_ROUTES.getRolePermissions(roleId), { method: "GET" });
  const json = await response.json();
  return json.data ?? [];
};

export async function saveRole(data) {
  const isUpdate = !!data.id;
  const res = await request(API_ROUTES.saveRol, {
    method: isUpdate ? "PUT" : "POST",
    body: JSON.stringify({
      nombre: data.name,
      descripcion: data.description,
      estado: data.estado,
      id: data.id ?? 0,
    }),
  });

  const json = await res.json();
  return json;
}
